/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CreditPlanStatus {
  STARTED = 'Started',
  EXECUTING = 'Executing',
  COMPLETED = 'Completed',
  FAILED = 'Failed',
  SKIPPED = 'Skipped'
}
